import React from 'react';
import cm from 'classnames';
import styles from './_button.module.scss';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
  outlined?: boolean;
  disabled?: boolean;
}

export const Button = React.forwardRef<HTMLButtonElement, Props>(
  ({ className, children, outlined, disabled, onClick, ...rest }, ref) => {
    return (
      <button
        ref={ref}
        className={cm(styles.root, className, { [styles['root--outlined']]: outlined, [styles.disabled]: disabled })}
        onClick={disabled ? undefined : onClick}
        {...rest}
      >
        {children}
      </button>
    );
  }
);
